// extracted by mini-css-extract-plugin
export var base = "_4b-0";
export var updateBanner = "_4b-1";